import { Component, OnInit } from '@angular/core';

export enum WriteType {
  overwrite,
  update,
  new
}

class ViewModel {
  writeType: WriteType;
  targetLocation: string;
  dataSource: string;
}

@Component({
    selector: 'app-write-database-transformer-detail',
    templateUrl: './write-database-transformer-detail.component.html',
    styleUrls: ['./write-database-transformer-detail.component.css'],
    standalone: false
})
export class WriteDatabaseTransformerDetailComponent implements OnInit {

  viewModel = new ViewModel();
  WriteType = WriteType;
  
  constructor() { }

  ngOnInit(): void {
  }

}
